module.exports = __webpack_public_path__ + "img/elsazeit.6a9b4de0.svg";